<button class="shortcut-menu__button" (click)="onClick($event)">
  <svg-icon src="assets/images/icons/notification.svg"></svg-icon>
  <span>{{ "ShortcutMenu.Tickets" | translate }}</span>
  <div class="shortcut-menu__badge" [class.blue]="count()">{{ count() }}</div>
</button>
